var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import WixComponent from '../BaseComponents/WixComponent';
import Input from '../Input';
import omit from 'omit';
import DropdownLayout from '../DropdownLayout/DropdownLayout';

var InputWithOptions = function (_WixComponent) {
  _inherits(InputWithOptions, _WixComponent);

  _createClass(InputWithOptions, [{
    key: 'inputClasses',


    // Abstraction
    value: function inputClasses() {}
  }, {
    key: 'dropdownClasses',
    value: function dropdownClasses() {}
  }, {
    key: 'dropdownAdditionalProps',
    value: function dropdownAdditionalProps() {}
  }, {
    key: 'inputAdditionalProps',
    value: function inputAdditionalProps() {}
  }]);

  function InputWithOptions(props) {
    _classCallCheck(this, InputWithOptions);

    var _this = _possibleConstructorReturn(this, (InputWithOptions.__proto__ || Object.getPrototypeOf(InputWithOptions)).call(this, props));

    _this.state = {
      inputValue: '',
      showOptions: false,
      lastOptionsShow: 0,
      isEditing: false
    };

    _this._onSelect = _this._onSelect.bind(_this);
    _this._onFocus = _this._onFocus.bind(_this);
    _this._onChange = _this._onChange.bind(_this);
    _this._onKeyDown = _this._onKeyDown.bind(_this);
    _this.focus = _this.focus.bind(_this);
    _this.blur = _this.blur.bind(_this);
    _this.select = _this.select.bind(_this);
    _this.hideOptions = _this.hideOptions.bind(_this);
    _this.showOptions = _this.showOptions.bind(_this);
    _this._onManuallyInput = _this._onManuallyInput.bind(_this);
    _this._renderDropdownLayout = _this._renderDropdownLayout.bind(_this);
    _this._onInputClicked = _this._onInputClicked.bind(_this);
    _this.closeOnSelect = _this.closeOnSelect.bind(_this);
    return _this;
  }

  _createClass(InputWithOptions, [{
    key: 'onClickOutside',
    value: function onClickOutside() {
      this.hideOptions();
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _this2 = this;

      var inputProps = Object.assign(omit(Object.keys(DropdownLayout.propTypes).concat(['onChange', 'dataHook']), this.props), this.inputAdditionalProps());
      var inputElement = inputProps.inputElement;

      return React.cloneElement(inputElement, _extends({
        menuArrow: true,
        ref: function ref(input) {
          return _this2.input = input;
        }
      }, inputProps, {
        theme: this.props.theme,
        onChange: this._onChange,
        onInputClicked: this._onInputClicked,
        onFocus: this.showOptions
      }));
    }
  }, {
    key: '_renderDropdownLayout',
    value: function _renderDropdownLayout() {
      var _this3 = this;

      var dropdownProps = Object.assign(omit(Object.keys(Input.propTypes).concat(['dataHook']), this.props), this.dropdownAdditionalProps());
      var customStyle = { marginLeft: this.props.dropdownOffsetLeft };
      if (this.props.dropdownWidth) {
        customStyle.width = this.props.dropdownWidth;
      }

      return React.createElement(
        'div',
        { className: this.dropdownClasses(), style: customStyle },
        React.createElement(DropdownLayout, _extends({
          ref: function ref(dropdownLayout) {
            return _this3.dropdownLayout = dropdownLayout;
          }
        }, dropdownProps, {
          theme: this.props.theme,
          visible: this.state.showOptions,
          onClose: this.hideOptions,
          onSelect: this._onSelect
        }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var dropDirectionUp = this.props.dropDirectionUp;

      return React.createElement(
        'div',
        null,
        dropDirectionUp ? this._renderDropdownLayout() : null,
        React.createElement(
          'div',
          { onKeyDown: this._onKeyDown, onFocus: this._onFocus, className: this.inputClasses() },
          this.renderInput()
        ),
        !dropDirectionUp ? this._renderDropdownLayout() : null
      );
    }
  }, {
    key: 'hideOptions',
    value: function hideOptions() {
      this.setState({ showOptions: false });
      this.input.blur();
    }
  }, {
    key: 'showOptions',
    value: function showOptions() {
      this.setState({ showOptions: true, lastOptionsShow: Date.now() });
    }
  }, {
    key: 'closeOnSelect',
    value: function closeOnSelect() {
      return this.props.closeOnSelect;
    }
  }, {
    key: '_onManuallyInput',
    value: function _onManuallyInput(inputValue) {
      inputValue = inputValue.trim();
      if (this.closeOnSelect()) {
        this.hideOptions();
      }

      var suggestedOption = this.props.options.find(function (element) {
        return element.value === inputValue;
      });

      if (this.props.onManuallyInput) {
        this.props.onManuallyInput(inputValue, suggestedOption);
      }
    }
  }, {
    key: '_onSelect',
    value: function _onSelect(option, isSelectedOption) {
      this.showOptions();
      var onSelect = this.props.onSelect;


      if (this.closeOnSelect()) {
        this.hideOptions();
      }

      if (isSelectedOption) {
        this.setState({ showOptions: false });
      } else if (onSelect) {
        onSelect(option);
      }
    }
  }, {
    key: '_onChange',
    value: function _onChange(event) {
      this.setState({ inputValue: event.target.value });

      if (this.props.onChange) {
        this.props.onChange(event);
      }
    }
  }, {
    key: '_onInputClicked',
    value: function _onInputClicked(event) {
      if (this.state.showOptions && Date.now() - this.state.lastOptionsShow > 2000) {
        this.hideOptions();
      }

      if (this.props.onInputClicked) {
        this.props.onInputClicked(event);
      }
    }
  }, {
    key: '_onFocus',
    value: function _onFocus() {
      if (this.props.disabled) {
        return;
      }
      this.setState({ isEditing: false });
      this.showOptions();
      if (this.props.onFocus) {
        this.props.onFocus();
      }
    }
  }, {
    key: '_onKeyDown',
    value: function _onKeyDown(event) {
      if (this.props.disabled) {
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
        this.setState({ isEditing: true });
      }
      if (!this.dropdownLayout._onKeyDown(event)) {
        switch (event.key) {
          case 'Enter':
          case 'Tab':
            {
              this._onManuallyInput(this.state.inputValue);
              break;
            }
          default:
            this.showOptions();
        }
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: 'select',
    value: function select() {
      this.input.select();
    }
  }]);

  return InputWithOptions;
}(WixComponent);

InputWithOptions.defaultProps = _extends({}, Input.defaultProps, DropdownLayout.defaultProps, {
  onSelect: function onSelect() {},
  options: [],
  closeOnSelect: true,
  inputElement: React.createElement(Input, null),
  valueParser: function valueParser(option) {
    return option.value;
  },
  dropdownWidth: null,
  dropdownOffsetLeft: '0'
});

InputWithOptions.propTypes = _extends({}, Input.propTypes, DropdownLayout.propTypes, {
  inputElement: PropTypes.element,
  closeOnSelect: PropTypes.bool,
  onManuallyInput: PropTypes.func,
  valueParser: PropTypes.func,
  dropdownWidth: PropTypes.string,
  dropdownOffsetLeft: PropTypes.string
});

InputWithOptions.displayName = 'InputWithOptions';

export default InputWithOptions;
//# sourceMappingURL=InputWithOptions.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/InputWithOptions/InputWithOptions.js